import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../styles/diario.scss'
import moment from "moment";

const Diario = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ],
        weekdays: [
            "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
        ]
    });

    const url1 = `/transparencia${props.diario.arquivo}`;
    const url2 = `/transparencia${props.diario.anexos}`;

    const lerDiario = async (url) => {
        props.onLerDiario(url)
    }

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                <Card.Header><h5>Edição Nº {props.diario.edicao} de {moment(props.diario.data_p).utc(false).format('dddd, DD [de] MMMM [de] YYYY')}</h5></Card.Header>
                    <Card.Body>
                        <Button type="button" variant="primary" onClick={() => lerDiario(url1)}>
                            Ler Diário
                        </Button>
                        <br/>
                        <br/>
                        {props.diario.num_anexos ? 
                        <a href={url2} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">Ver Anexo</Button>
                        </a> : ''}
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Diario;